import React, { Component, Fragment } from "react";
import { Helmet } from "react-helmet";
import { Link, withRouter } from "react-router-dom";
import { Row, Col, Button } from "reactstrap";
import axios from "axios";
import Moment from "moment";
import { trackPromise } from "react-promise-tracker";

import classes from './DrivePage.module.scss';
import Table from "./../../components/general/Table/Table";
import EditProblemModal from "./../../components/page/fixlist/EditProblemModal/EditProblemModal";
import Title from "./../../components/general/AdminPageTitle/AdminPageTitle";
import Loading from "../../components/wrapper/Loading/Loading";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

class FixListPage extends Component{

  state = {
    tableData: [],
    closedTableData: [],
    tableHeaders: [],
    modalEdit: true,
    isLoading: false
  };

  fixListButtons = [
    {
      display: "View",
      onClickHandler: (index, id) => {
        let problem = this.state.tableData.find((item) => item[0] === id);
        let data = {
          id: problem[0],
          vendor_name: problem[1],
          //truck_id: problem[3],

        };
        //console.log("id: " + id + " data: " + JSON.stringify(data));
        this.setState({
          modalEdit: true,
          modalData: data,
          modalShow: true
        });
      }
    }
  ];
  closedFixListButtons = [
    {
      display: "View",
      onClickHandler: (index, id) => {
        let problem = this.state.closedTableData.find((item) => item[0] === id);
        let data = {
          id: problem[0],
          vendor_name: problem[1],
          //truck_id: problem[3],

        };
        //console.log("id: " + id + " data: " + JSON.stringify(data));
        this.setState({
          modalEdit: true,
          modalData: data,
          modalShow: true
        });
      }
    }
  ];
  fixListHeaders = ["id", "Vendor Name", "Truck Name", "Description", "Date Identified", "Bleeding Stopped", "Reprint Ordered", "Solution", "Target Close Date"];

  getFixListData = () => {
    this.setState({
      isLoading: true
    })
    trackPromise(
    axios
    .get(`${process.env.REACT_APP_API_HOST}/fixlist`, {withCredentials: true})
    .then((response) => {
      let closed_problems = [];
      let problems = response.data.problem
      .filter(function (problem){
        if (problem.closed == true){
          closed_problems.push(problem);
          return false;
        }
        return true;
      }).map((problem, index) => {
        return [problem.truck_problem_id, problem.vendor_name, problem.truck_name, problem.description, Moment(problem.date_identified).format("YYYY-MM-DD"), problem.bleeding_stopped, problem.reprint_ordered, problem.solution, Moment(problem.target_close_date).format("YYYY-MM-DD"), problem.truck_id];
      });

      closed_problems = closed_problems.map((problem, index) => {
        return [problem.truck_problem_id, problem.vendor_name, problem.truck_name, problem.description, Moment(problem.date_identified).format("YYYY-MM-DD"), problem.bleeding_stopped, problem.reprint_ordered, problem.solution, Moment(problem.target_close_date).format("YYYY-MM-DD"), problem.truck_id];
      });
      // sort clients by name alphabetically ascending
      problems = problems.sort((a, b) => {
        let first = a[1].toUpperCase();
        let second = b[1].toUpperCase();
        return (first === "") - (second === "") || +(first > second) || -(first < second);
      });
      this.setState({
        tableData: problems,
        closedTableData: closed_problems,
        isLoading: false
      });
    })
    .catch((err) => {
      this.setState({
        isLoading: false
      });
      console.log(err);
    })
  );
  };

  toggleModal = (refreshTable) => {
    this.setState({
      modalShow: false,
    });
    if (refreshTable){
      this.getFixListData();
    }
  };

  newItemModal = () => {
    this.setState({
      modalEdit: false,
      modalShow: true,
    });
  };

  componentDidMount() {
    this.getFixListData();
  }
  render(){
    return (
      <Fragment>
        <Loading loading={this.state.isLoading} label="Loading Fix List Items..."></Loading>
      <Helmet>
      <title>Boxi Admin | Fix List</title>
      </Helmet>
      <div className={`${classes.titleContainer} mb-4`}>
        <Title>Fix List</Title>
        <div className={classes.linksContainer}>
          <div onClick={this.newItemModal} className={classes.linkTag}>
            + New Fix List Item
          </div>
        </div>
      </div>
      <Row className="mb-4">
      <Col lg="12">
      <Table
      id="fixlist-table"
      title="Open Fix List Items"
      headers={this.fixListHeaders}
      data={this.state.tableData}
      buttons={this.fixListButtons}
      colors={["#FC575E", "#F7B42C"]}
      ></Table>
      </Col>
      <EditProblemModal toggleModal={this.toggleModal} show={this.state.modalShow} data={this.state.modalData} edit={this.state.modalEdit}/>
      {/* <Button style={{marginLeft: 25 + 'px'}} onClick={this.newItemModal}>  New Fix List Item </Button> */}
      </Row>
      <Row className="mb-4">
      <Col lg="12">
      <Table
      id="fixlist-closed-table"
      title="Closed Fix List Items"
      headers={this.fixListHeaders}
      data={this.state.closedTableData}
      buttons={this.closedFixListButtons}
      colors={["#BCBEC2", "#E1E4E8"]}
      ></Table>
      </Col>
      </Row>

      </Fragment>
    );
  }
}

export default withRouter(FixListPage);
